import { Divider } from '@mui/material'
import { CoreTypography, useTheme } from '@thriveglobal/thrive-web-leafkit'
import { FormattedMessage } from 'react-intl'

const SignInMethodDivider = ({ lightBackground = false }) => {
    const theme = useTheme()
    return (
        <>
            <Divider
                sx={{
                    flexGrow: 1,
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    borderColor: lightBackground
                        ? theme.palette.divider
                        : theme.palette.secondary.main
                }}
            />
            <CoreTypography
                uppercase
                customVariant="form"
                sx={{ margin: '0 16px' }}
            >
                <FormattedMessage
                    description="Text to let users know there are other methods of signing up"
                    defaultMessage="Or"
                />
            </CoreTypography>
            <Divider
                sx={{
                    flexGrow: 1,
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    borderColor: lightBackground
                        ? theme.palette.divider
                        : theme.palette.secondary.main
                }}
            />
        </>
    )
}

export default SignInMethodDivider
